import { BN, DriftClient, PerpMarketConfig, User, ZERO } from '@drift-labs/sdk';
import { COMMON_UI_UTILS, OpenPosition } from '@drift/common';
import { PositionsResult } from './types';

export function computePositions(
	user: User,
	driftClient: DriftClient,
	perpMarketsLookup: PerpMarketConfig[],
	markPriceCallback: (marketIndex: number) => BN
): PositionsResult {
	if (perpMarketsLookup.length === 0) {
		return {
			openPerpPositions: [],
			totalUnsettledPnl: ZERO,
			marketsNeedingSettlement: [],
		};
	}

	const userAccountPositions = user.getUserAccount().perpPositions;

	let openPerpPositions: OpenPosition[];
	try {
		openPerpPositions = COMMON_UI_UTILS.getOpenPositionData(
			driftClient,
			userAccountPositions,
			user,
			perpMarketsLookup,
			markPriceCallback
		);
	} catch (error) {
		console.error('Error getting open positions:', error);
		openPerpPositions = [];
	}

	const totalUnsettledPnl = openPerpPositions.reduce(
		(a, b) => a.add(b.unsettledPnl),
		ZERO
	);

	const totalUnrealizedPnl = openPerpPositions.reduce(
		(a, b) => a.add(b.totalUnrealizedPnl),
		ZERO
	);

	let marketsNeedingSettlement: number[] = [];
	if (totalUnsettledPnl.lt(totalUnrealizedPnl)) {
		marketsNeedingSettlement = openPerpPositions
			.filter((pos) => pos.totalUnrealizedPnl.gt(pos.unsettledPnl))
			.map((pos) => ({
				diff: pos.totalUnrealizedPnl.sub(pos.unsettledPnl),
				marketIndex: pos.marketIndex,
			}))
			.sort((a, b) => b.diff.toNumber() - a.diff.toNumber())
			.map((val) => val.marketIndex);
	}

	return {
		openPerpPositions,
		totalUnsettledPnl,
		marketsNeedingSettlement,
	};
}
